export class AutoshipMemberInfo{
    memberId:number;
    memberLevel:string;
     memberLevelId:number;
    homeCountry:String;
    currencySymbol:string;
    wholesaleQualified:any;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/autoship-memberinfo.ts